export const PRODUCT_PAGE_CONFIG = {
    sale: {
        defaultFilters: {
            is_sale: true
        },
        meta: {
            title: "Sale",
        }
    },
    specialSale: {
        defaultFilters: {
            is_special_sale: true
        },
        meta: {
            title: "Special Sale",
        }
    },
    tester: {
        defaultFilters: {
            is_tester: true
        },
        meta: {
            title: "Testers Product",
        }
    }
};
